import api from '@/services/api'

export const getExpectancies = async (indicatorID, indicatorType) => {
    try {
        if (indicatorType == 'target') {
            return getTargetExpectations(indicatorID)
        } else if (indicatorType == 'kpi') {
            return getKpiExpectations(indicatorID)
        }
    } catch (error) {
        console.log(error)
    }
}

const getTargetExpectations = async targetID => {
    try {
        const resp = await api.get(
            `goals/${targetID}/checkins/get-simulated-accomplisheds`
        )
        return resp.data.data
    } catch (error) {
        console.log(error)
    }
}

const getKpiExpectations = async kpiID => {
    try {
        const resp = await api.get(
            `kpi/${kpiID}/checkins/get-simulated-accomplisheds`
        )
        return resp.data.data
    } catch (error) {
        console.log(error)
    }
}

export const saveSimulatedCheckIns = async (
    form,
    indicatorId,
    indicatorType
) => {
    try {
        if (indicatorType == 'target') {
            return saveTargetSimulatedCheckIns(form, indicatorId)
        }
        return saveKpiSimulatedCheckIns(form, indicatorId)
    } catch (error) {
        console.log(error)
    }
}

const saveKpiSimulatedCheckIns = async (form, indicatorId) => {
    return api.post(`kpi/${indicatorId}/checkins/store-simulated-checkins`, {
        indicator_id: indicatorId,
        data: form,
    })
}

const saveTargetSimulatedCheckIns = async (form, indicatorId) => {
    return api.post(`goals/${indicatorId}/checkins/store-simulated-checkins`, {
        indicator_id: indicatorId,
        data: form,
    })
}
